import React from 'react'
import RightStep from './RightStep'
import LeftStep from './LeftStep'
import './ProductStep.scss'

const ProductStep = (props) => props.direction === 'right' ? <RightStep {...props} /> : <LeftStep {...props} />

export default ProductStep;


// WEBPACK FOOTER //
// ./src/components/ProductStep/index.js